import {Version} from "@/sdk.ts";

export function minVersion(curVersion: Version, minVersion: Version): boolean {
  // Check that the actual version is either :
  // - at least `minVersion`
  // - within `minVersion` & `maxVersion` range.
  // We assume versions respect Semantic Versioning, and are written in string of the form `${major}.${minor}.${patch}`.
  const [curMajor, curMinor, curPatch] = curVersion.split('.', 2);
  const [minMajor, minMinor, minPatch] = minVersion.split('.', 2);
  if (curMajor < minMajor) {
    return false;
  } else if (curMajor === minMajor) {
    if (curMinor < minMinor) {
      return false;
    } else if (curMinor === minMinor && curPatch < minPatch) {
      return false;
    }
  }

  return true;
}

export function maxVersion(curVersion: Version, maxVersion: Version): boolean {
  const [curMajor, curMinor, curPatch] = curVersion.split('.', 2);
  const [maxMajor, maxMinor, maxPatch] = maxVersion.split('.', 2);

  if (curMajor > maxMajor) {
    return false;
  } else if (curMajor === maxMajor) {
    if (curMinor > maxMinor) {
      return false;
    } else if (curMinor === maxMinor && curPatch > maxPatch) {
      return false;
    }
  }

  return true;
}